"use strict";Object.defineProperty(exports,"__esModule",{value:!0});
/**
 * This function will wait for utag to exist on window, checking with a provided interval,
 * and executed the provided callbacks on success or on timeout.
 *
 * @param onSuccess - function to execute if utag exists on window
 * @param onTimeout (default: () => {})  - function to execute after timeout if utag does not exist on window
 * @param intervalMs (default: 1000) - interval (ms) between checks for utag
 * @param maxWaitingTimeMs (default: 10000) - total time (ms) before timeout
 */
var waitForUtag=function(t){var e=t.onSuccess,i=t.onTimeout,o=void 0===i?function(){
/* NO-OP */}:i,a=t.intervalMs,n=void 0===a?1e3:a,r=t.maxWaitingTimeMs,w=void 0===r?1e4:r,s=0,v=window.setInterval(function(){window.utag?(e(),window.clearInterval(v)):w<(s+=n)&&(o(),window.clearInterval(v))},n)};exports.waitForUtag=waitForUtag;
